import React from 'react'
import { Flex, Heading, Spinner } from '@theme-ui/components'
import LazyLoad from 'react-lazyload'
import LinkSelector from '../../Links/LinkSelector'
import ImageSelector from '../../Images/ImageSelector'
import backgroundStylesGradient from '../../../helpers/backgroundStylesGradient'
import TextBodySelector from '../../General/TextBodySelector'
import componentOptionsSelector from '../../../helpers/componentOptionsSelector'
import AnimationSelector from '../../Animation/AnimationSelector'
import slugifyLower from '../../../helpers/slugifyLower'
import useForceCheckLazyLoaded from '../../../hooks/useForceCheckLazyLoaded'
import MultipleLinksSelector from '../../Links/MultipleLinksSelector'

export default function SideBySideV1(props) {
  // ? ===================
  // ? === Destructing ===
  // ? ===================
  const {
    options,
    businessData,
    variantName,
    isMultiLocationSite,
    locationIndex,
    poweredImages,
    allGeneral
    // city,
    // configData,
    // customPageName,
    // pageComponents,
    // locations,
    // pageObjectKey,
    // pageTitle,
    // gonationID,
  } = props

  const { city, desc } = businessData

  // ? =============
  // ? === Hooks ===
  // ? =============

  useForceCheckLazyLoaded() // check to see if its in screen on load and does checks to load it manually

  // ? =====================
  // ? === Data Selector ===
  // ? =====================

  const storyId = options.storyId?.[locationIndex]
  const storyTag = options.storyTag?.[locationIndex]

  // this function finds hardcoded options by location index and then decides whether to use gonation story data if storyid is provided
  const {
    className,
    titles,
    subtitles,
    texts,
    textType,
    ctaLinks,
    ctaNames,
    links,
    images,
    restrictCharacters,
    backgroundImages,
    backgroundGradient,
    containerStyles,
    animation
  } = componentOptionsSelector(options, locationIndex, storyId, allGeneral, storyTag)

  const { video } = options

  // ? =================
  // ? === Variables ===
  // ? =================

  // checks if the component has any content to render if it does render it if not don't
  const hasContent = titles || subtitles || texts || ctaLinks || ctaNames || images || backgroundImages

  // ? ===========================
  // ? === Styles Manipulation ===
  // ? ===========================

  const backgroundStyles = backgroundImages
    ? backgroundStylesGradient(backgroundImages, backgroundGradient, poweredImages, locationIndex)
    : ''

  const styles = containerStyles ? JSON.parse(containerStyles) : {}

  // ? ================
  // ? === Main JSX ===
  // ? ================

  if (!hasContent) {
    return null // if there component has no content to render don't render it
  }

  return (
    <AnimationSelector animation={animation}>
      <Flex
        variant={`${variantName}.container`}
        sx={{ background: backgroundStyles, ...styles }}
        className={`container ${storyId ? `${storyId} ${slugifyLower(storyId)}` : ''} ${className}`}
        id={`${storyId ? storyId : ''}`}
      >
        <Flex variant={`${variantName}.content`} className="content">
          {titles && (
            <Heading variant={`${variantName}.title`} className="title">
              {titles}
            </Heading>
          )}
          {subtitles && (
            <Heading variant={`${variantName}.subtitle`} className="subtitle">
              {subtitles}
            </Heading>
          )}

          <TextBodySelector
            variantName={`${variantName}`}
            texts={texts}
            textType={textType}
            restrictCharacters={restrictCharacters}
            desc={desc}
          />

          {links?.length > 0 ? (
            <MultipleLinksSelector
              links={links}
              variant={`${variantName}`}
              isMultiLocationSite={isMultiLocationSite}
              city={city}
            />
          ) : null}
        </Flex>

        {images && images.length > 0 && (
          <LazyLoad
            height={'400'}
            once
            placeholder={
              <Flex
                sx={{
                  justifyContent: 'center',
                  alignItems: 'center',
                  paddingBottom: '100%'
                }}
              >
                <Spinner />
              </Flex>
            }
          >
            {video?.length ? (
              <video
                src={video}
                controls
                autoPlay={false}
                style={{
                  maxWidth: 480,
                  margin: 'auto',
                  display: 'flex'
                  //   width: '100%',
                }}
              ></video>
            ) : (
              <ImageSelector
                variant={`${variantName}.image`}
                image={Array.isArray(images) ? images[0] : images}
                poweredImages={poweredImages}
                className="image"
                locationIndex={locationIndex}
              />
            )}
          </LazyLoad>
        )}
      </Flex>
    </AnimationSelector>
  )
}
